export const ALLOWED_RESOURCE_ORIGINS: readonly string[] = [
  'https://storage.googleapis.com',
  'https://www.youtube.com',
  'https://youtube.com',
  'https://firebasestorage.googleapis.com',
  'https://api.sketchplay.io',
];

export const SKETCHPLAY_TERMS_CONDITIONS_URL =
  'https://sketchplay.com/legal/terms-and-conditions/';

export enum TypeFormat {
  POST = 'post',
  EVENT = 'event',
  TOURNAMENT = 'tournament',
  PRODUCT = 'product',
  PROFILE = 'profile',
  EXPORT = 'export',
  MEDIA = 'media',
  PAYMENT = 'payment',
  ORGANIZATION = 'organization',
  CAMPAIGN = 'campaign',
}

export const API_FEATURE = {
  GET_ACTIVE_FEATURE: 'features/list/active',
  GET_ALL_STATES: 'country/states',
  GET_ALL_CITIES: 'country/cities',
  GET_GRADES: 'grade/no-auth',
};

export const API_CALENDAR = {
  GET_CALENDAR: 'event/for/calendar/marketing',
  GET_TOURNAMENT_CALENDAR: 'tournament/list/for/calendar/marketing',
  GET_GAME_CALENDAR: 'tournament/list/games/for/calendar/marketing',
};

export const API_EVENT = {
  MARKETING: 'event/marketing',
  DAILY_TRAINING: 'event/marketing/daily-training',
  INSURANCE: 'event/marketing/insurance',
  LACROSSE_CHECK: 'event/lacrosse/check',
};

export const API_EVENT_PLAYER = {
  USER_CHECK: 'event-player/user/check',
  CHECK_REGISTER_ATHLETE: 'event-player/check-register/athlete/marketing',
  EVENT_MARKETING_INTENT: 'event-player/event-marketing-intent',
  EVENT_REGISTER: 'event-player/marketing/event/register',
  EVENT_REGISTER_FREE: 'event-player/marketing/event/register/free',
  EVENT_PAYMENT_PRODUCT: 'event-player/marketing/event-payment/product',
  EVENT_INTENT_PAYMENT_PLAN: 'event-player/marketing/event-intent/payment-plan',
  EVENT_PAYMENT_PAYMENT_PLAN:
    'event-player/marketing/event-payment/payment-plan',
};

export const API_PAYMENT_BOOKING = {
  SAVE_PUBLIC: 'payment-booking/public',
};

export const API_TOURNAMENT = {
  MARKETING: 'tournament/marketing',
  MARKETING_PRODUCTS: 'tournament/marketing/products',
  PAYMENT_INTENT: 'tournament/payment-intent',
  REGISTRATION: 'tournament/registration',
  SELF_REGISTRATION: 'tournament/self-registration',
  SELF_REGISTRATION_TEAMS: 'tournament/marketing/register/team/list',
  APPLY_DISCOUNT: 'tournament/apply/discount',
  SKETCHPLAY_BUCKS_CHECK: 'tournament/marketing/sketchplay-bucks',
  ACH_SETUP_INTENT: 'tournament/ACH/setup/intent/marketing',
  ACH_PAYMENT_INTENT: 'tournament/ACH/payment/intent/marketing',
  REGISTER_TEAMS: 'tournament/register/teams',
  REGISTER_TEAM_ROSTER_DOCUMENTS:
    'tournament/register/team/roster/uploaded/documents',
  REGISTER_TEAM: 'tournament/register/team',
  UPDATE_REGISTER_TEAM_ROSTER: 'tournament/update/register/team/roster',
  ADD_MANUAL_ROSTER_PLAYER: 'tournament/self-registration/manual/public',
  ROSTER_PLAYER: 'tournament/team/roster/player',
  CHECK_COST_WISE_SPOT: 'tournament/check/cost/wise/spot',
  STANDING: 'tournament/marketing/standing',
  DIVISION_AGE_GROUP: 'tournament/marketing/division/age-group',
  POOLS: 'tournament/marketing/pools',
  SCHEDULE_MATCHES: 'tournament/marketing/schedule/matches',
  SCHEDULE_EXPORT: 'tournament/marketing/export/schedule',
  BRACKET_LIST: 'tournament/bracket/list/marketing',
  UPLOAD_ROSTER_DOCUMENTS: 'tournament/upload/roster/documents',
  REGISTRATION_TEAMS_PLAYER: 'tournament/marketing/registration/teams/player',
  CUSTOM_TEAM_LIST: 'tournament/marketing/custom/team/list',
  TEAM_COACHES: 'tournament/team/coaches',
  ADD_TEAM_COACH: 'tournament/add/team/coach',
  UPDATE_TEAM_COACH: 'tournament/update/team/coach',
  UPDATE_REGISTER_TEAM_NAME: 'tournament/update/register/team/name',
  REMOVE_TEAM_COACH: 'tournament/remove/team/coach',
  UPDATE_REGISTER_TEAM_WAIVER: 'tournament/update/register/team/waiver',
  ROSTER_INFORMATION: 'tournament/roster/information',
  EXPORT_TEAM_COACHES: 'tournament/export/team/coaches',
  DOWNLOAD_SINGLE_ROSTER_DOCUMENTS_ZIP:
    'tournament/download/single/roster/documents/zip',
  DOWNLOAD_ROSTER_DOCUMENTS_ZIP:
    'tournament/marketing/download/roster/documents/zip',
  EXPORT_TEAM: 'tournament/export/team',
  UPDATE_TEAM_SOCIAL_LINKS: 'tournament/update/team/sociallinks',
  ALL_TEAMS: 'tournament/marketing/all/teams',
  BRACKET_MATCH_TEAM: 'tournament/marketing/bracket/match/team',
  DOWNLOAD_ROSTER_TEMPLATE: 'tournament/download-roster-template',
  INTENT_PAYMENT_PLAN: 'tournament/plan-payment-intent',
  PAYMENT_PAYMENT_PLAN: 'tournament/plan-registration',
  DOWNPAYMENT_CALCULATION: 'tournament/marketing/downpayment/calculation',
  INTENT_DOWNPAYMENT: 'tournament/downpayment-payment-intent',
  PAYMENT_DOWNPAYMENT: 'tournament/downpayment-registration',
};

export const API_NSID_VERIFICATION = {
  PUBLIC_TEAM_STATUS: 'nsid-verification/public/team',
};

export const API_BRACKETS = {
  MARKETING: 'brackets-poc/marketing',
  GENERATE: 'generate',
  MATCH_UPDATE: 'match/update',
};

export const API_PRODUCT = {
  MARKETING_LIST: 'product/marketing/list',
  MARKETING_SUBSCRIPTION_LIST: 'product/marketing/subscription/list',
  PRODUCT_INTENT: 'product/marketing/product-intent',
  PRODUCT_SUBSCRIPTION_INTENT: 'product/marketing/product-subscription-intent',
  PRODUCT_PAYMENT: 'product/marketing/product-payment',
  PRODUCT_SUBSCRIPTION_PAYMENT:
    'product/marketing/product-subscription-payment',
  ELIGIBLE_PRODUCT: 'product/marketing/eligible-product',
  CHECK_PRODUCT: 'product/marketing/check-product',
  PRODUCT_PAYMENT_FREE: 'product/marketing/product-payment/free',
  PRODUCT_INTENT_PAYMENT_PLAN: 'product/marketing/product-intent/payment-plan',
  PRODUCT_PAYMENT_PAYMENT_PLAN:
    'product/marketing/product-payment/payment-plan',
  MARKETING_DETAIL: 'product/marketing',
};

export const API_DISCOUNT = {
  CHECK_NO_AUTH: 'discount/check-no-auth',
  MARKETING_PACKAGE_CHECK: 'discount/marketing/package/check',
};

export const API_PAYMENT_PLAN = {
  MARKETING_DATE: 'payment-plan/marketing/date',
  MARKETING_EVENT_CALCULATION: 'payment-plan/marketing/event/calculation',
  MARKETING_PRODUCT_CALCULATION: 'payment-plan/marketing/product/calculation',
  MARKETING_TOURNAMENT_CALCULATION:
    'payment-plan/marketing/tournament/calculation',
};

export const API_MEDIA = {
  DOCUMENT_NO_AUTH_NAME: 'media/document-no-auth/name',
  DOWNLOAD_DOCUMENT_NO_AUTH: 'media/download/document-no-auth',
};

export const API_COMMON = {
  WEB_SETTING: 'webSetting/settings',
  CONTACT_US: 'contact-us',
  WEB_LOGIN: 'web-login',
  USER_BY_INFO: 'user/by/info',
  SKETCHPLAY_BUCKS: 'marketing/sketchplay-bucks',
  CUSTOM_FORM_MARKETING: 'custom-form/marketing',
};

export const API_WEBSITE_GATE = {
  PUBLIC: 'website-gate/public',
};

export const API_LOCATION = {
  GET_LOCATION_LIST: 'country/find/address',
  GET_LOCATION_DETAILS: 'country/find/detail/address',
};
